import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../components/Login';
import OAuthCallback from '../pages/OAuthCallback';
import StoresPage from '../pages/StoresPage';
import WorkersPage from '../pages/WorkersPage';
import PartnersPage from '../pages/PartnersPage';
import ProgramsPage from '../pages/ProgramsPage';
import ChainsPage from '../pages/ChainsPage';
import BusinessTypesPage from '../pages/BusinessTypesPage';
import PlansPage from '../pages/PlansPage';
import SettingsPage from '../pages/SettingsPage';
import OptimizationTasksPage from '../pages/OptimizationTasksPage';
import Profile from '../pages/Profile';
import MapTest from '../components/MapTest';
import MainLayout from '../layouts/MainLayout';
import ProtectedRoute from './ProtectedRoute';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/oauth/callback" element={<OAuthCallback />} />
      
      {/* Protected routes with MainLayout */}
      <Route element={<ProtectedRoute />}>
        <Route element={<MainLayout />}>
          {/* Plans with nested routes for specific plan */}
          <Route path="/plans">
            <Route index element={<PlansPage />} />
            <Route path=":planId" element={<PlansPage />} />
          </Route>
          
          {/* Partners with nested routes */}
          <Route path="/partners">
            <Route index element={<PartnersPage />} />
            <Route path=":partnerId" element={<PartnersPage />} />
          </Route>
          
          {/* Programs with nested routes */}
          <Route path="/programs">
            <Route index element={<ProgramsPage />} />
            <Route path=":programId" element={<ProgramsPage />} />
          </Route>
          
          {/* Chains with nested routes */}
          <Route path="/chains">
            <Route index element={<ChainsPage />} />
            <Route path=":chainId" element={<ChainsPage />} />
          </Route>
          
          {/* Stores with nested routes */}
          <Route path="/stores">
            <Route index element={<StoresPage />} />
            <Route path=":storeId" element={<StoresPage />} />
          </Route>
          
          {/* Workers with nested routes */}
          <Route path="/workers">
            <Route index element={<WorkersPage />} />
            <Route path=":workerId" element={<WorkersPage />} />
          </Route>
          
          {/* Business Types with nested routes */}
          <Route path="/business-types">
            <Route index element={<BusinessTypesPage />} />
            <Route path=":businessTypeId" element={<BusinessTypesPage />} />
          </Route>
          
          {/* Optimization Tasks with nested routes */}
          <Route path="/optimization-tasks">
            <Route index element={<OptimizationTasksPage />} />
            <Route path=":taskId" element={<OptimizationTasksPage />} />
          </Route>
          
          {/* Other routes */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/map-test" element={<MapTest />} />
          
          {/* Default route */}
          <Route path="/" element={<PlansPage />} />
        </Route>
      </Route>
      
      {/* Fallback route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;